<template>
  <div class="home" data-automation="home">
    <div class="home-content">
      <my-header
        show-collapse
        show-user-name
        show-work-order
        :is-collapse="isCollapse"
        @switch-menu="switchMenu"
      ></my-header>
      <!-- 内容 -->
      <div class="home-main">
        <!-- 侧边栏 -->
        <div :class="['left-menu x-flex-y', { 'is-collapse': isCollapse }]" slot="left">
          <!-- 菜单 -->
          <ux-menu
            light
            :class="['home-menu', 'x-flex-one', isAppShow ? 'ux-menu-app-show' : '']"
            ref="menu"
            v-model="activeMenu"
            :list="menuData"
            index="url"
            :props="props"
            :isCollapse="isCollapse"
            @click="uxClick"
          ></ux-menu>
        </div>

        <!-- 右视图 -->
        <div class="main" slot="right">
          <!-- 头部 -->
          <div class="header x-flex-between" data-automation="header">
            <!-- 面包屑 -->
            <ux-breadcrumb :data="breadData"></ux-breadcrumb>
            <!-- <upper-user :data="userData" @close="logout"></upper-user> -->
          </div>

          <!-- 主视图 -->
          <div class="main-view" data-automation="main">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myHeader from '@c/myHeader/myHeader';

import { saveSessionStorage, getLocalStorage } from '@l/localStorage.js';
export default {
  components: {
    myHeader
  },
  data() {
    return {
      props: {
        icon: 'icon',
        name: 'menu_name',
        children: 'child_menu'
      },
      isCollapse: true, // 迷你侧边栏是否显示
      activeMenu: '', // 当前激活菜单
      userData: {}, // 用户信息
      breadData: [], // 面包屑数据
      isAppShow: false
    };
  },
  created() {
    this.breadData = this.$route.meta.bread; // 面包屑数据
    this.$store.commit('saveBreadData', this.breadData); // 保存面包屑数据
    this.activeMenu = this.$route.meta.active; // 当前激活高亮菜单
    this.isCollapse = getLocalStorage('isCollapse') || false;
    this.userData = this.$store.state.login.userData;
    this.getMenu();
  },

  methods: {
    /**
     * 方法
     * @param {String} index 唯一标识
     * @param {Object} item 菜单详细数据
     */
    uxClick(index) {
      if (this.activeMenu === index) return;
      if (index) {
        this.$router.push(`/${index}`); //菜单跳转
      }
    },

    switchApp() {
      this.isCollapse = false;
      this.isAppShow = !this.isAppShow;
    },

    /**
     * 退出登录
     */
    logout() {
      this.$api.login.logout();
      this.$store.commit('logout');
      this.$router.push('/login');
      this.$uxModal.hide();
    },

    /**
     * 切换侧边栏模式
     */
    switchMenu() {
      this.isCollapse = !this.isCollapse;
      saveSessionStorage('isCollapse', this.isCollapse);
    },

    /**
     * 点击菜单栏
     * @param {String} index 当前菜单栏绑定的index
     */
    selectMenu(index) {
      let url = `/${index}`;
      this.$router.push(url);
      this.activeMenu = index;
    },

    getMenu() {
      this.$getMenu().then(() => {
        if (this.$route.path === '/home') {
          this.$nextTick(() => {
            const menus = this.$store.state.login.userMenu;
            this.$router.push(`/${menus[0]}`);
          });
        }
      });
    }
  },

  computed: {
    storeBreadData() {
      return this.$store.state.login.breadData;
    },
    storeMenuData() {
      return this.$store.state.login.menuData;
    },
    // 菜单数据
    menuData() {
      // 去除工单服务
      return this.storeMenuData
        .filter((item) => Number(item.id) !== 53)
        .map((item) => {
          const res = {
            ...item,
            menu_name: item.menu_key ? this.$t(item.menu_key) : item.menu_name
          };

          if (res.child_menu.length > 0) {
            res.child_menu = res.child_menu.map((child) => {
              return {
                ...child,
                menu_name: child.menu_key ? this.$t(child.menu_key) : child.menu_name
              };
            });
          }
          return res;
        });
    }
  },

  watch: {
    /**
     * 监听路由改变
     */
    $route(val) {
      this.breadData = val.meta.bread;
      this.$store.commit('saveBreadData', this.breadData); // 保存面包屑数据
      this.activeMenu = val.meta.active;
      this.isAppShow = false;
    },

    storeBreadData(val) {
      this.breadData = val;
    }
  }
};
</script>

<style lang="scss" scoped>
$header-bar: 60px; // 头部栏高度
$menu-color: #161e28; // 菜单栏背景色

.home {
  position: relative;
  width: 100%;
  overflow: auto;
  height: 100%;

  .my-header {
    position: relative;
    box-shadow: 0px 2px 6px 0px $color-box-shadow;
    background: #fff;
  }

  .home-content {
    position: relative;
    min-width: 1280px;
    height: 100%;
    z-index: 2;
    min-height: 800px;
  }

  .home-main {
    position: relative;
    display: flex;
    width: 100%;
    height: calc(100% - 60px);
    margin: 0 auto;
    background: $color-bg-disable;
    overflow: hidden;
  }

  .home-side {
    position: relative;
    flex: 0 0 auto;
    width: 240px;
    height: 100%;
    margin-top: 20px;
    box-sizing: border-box;
  }

  .home-view-box {
    padding-left: 20px;
    flex: 1;
    height: 100%;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
  }

  .home-view {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 2;
    box-sizing: border-box;
    padding-right: 40px;
  }

  .left-menu {
    position: relative;
    z-index: 4;
    height: 100%;
    background-color: $menu-color;
    user-select: none;

    .slogan {
      box-sizing: border-box;
      position: relative;
      width: 100%;
      height: $header-bar;
      padding-left: 20px;
      background-color: #161e28;
      color: #fff;

      .spread,
      .ux-dropdown {
        position: absolute;
        top: 24px;
        right: 15px;
        color: $color-primary;
        cursor: pointer;
        transition: all 0.6s;
        transform-origin: center;
      }
      .animate1 {
        transform: rotateY(180deg);
      }

      .animate2 {
        transform: rotateY(0deg);
      }

      .app-spread {
        display: none;
      }
    }
  }

  .main {
    position: relative;
    flex: 1;
    width: 100%;
    height: 100%;
    background-color: #f6f8fc;
    overflow: hidden;

    // 头部
    .header {
      position: relative;
      z-index: 2;
      height: $header-bar;
      padding: 0 20px;
    }

    // 主视图
    .main-view {
      position: absolute;
      display: flex;
      flex-direction: column;
      top: 40px;
      bottom: 0;
      width: 100%;
      overflow: auto;
    }

    ::v-deep .ux-breadcrumb {
      .x-blue-text.iconfont {
        display: none;
      }
    }
  }

  .left-menu {
    width: 240px;
    background: #fff;
    transition: all 0.2s ease-in-out;

    ::v-deep .home-menu {
      width: 200px;
      margin-left: 20px;
      background: #fff;
      border-right: none;
      transition: all 0.2s ease-in-out;

      .menu-icon {
        color: $color-text-disable;
      }

      .ux-menu-item {
        height: 48px;
        transition: all 0.2s ease-in-out;

        &:hover {
          color: $color-primary;

          .menu-name,
          .menu-icon {
            color: $color-primary;
          }
        }

        &.default-active {
          background: $color-primary;
          border-radius: 8px;
          color: #fff;

          .menu-name,
          .menu-icon {
            color: #fff;
          }
        }

        .menu-name {
          font-weight: 400;
          font-size: 14px;
          color: $color-text;
        }
      }

      .ux-menu-children {
        .ux-menu-item {
          &:hover {
            color: $color-primary;

            .menu-name {
              color: $color-primary;
            }
          }

          .menu-icon {
            display: none;
          }

          &.default-active {
            position: relative;
            background: none;
            border-radius: 8px;
            color: $color-primary;

            &::before {
              content: '';
              position: absolute;
              right: 0;
              top: 50%;
              margin-top: -4px;
              width: 4px;
              height: 8px;
              background: $color-primary;
            }

            .menu-name {
              color: $color-primary;
            }
          }
          .menu-name {
            font-weight: 400;
            font-size: 14px;
          }
        }
      }

      .ux-menu-light.ux-menu-children {
        background: #fff;
      }
    }

    &.is-collapse {
      width: 64px;

      ::v-deep .home-menu {
        width: 40px;

        .ux-menu-item {
          height: 40px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
@media screen and (max-width: 800px) {
  .home {
    &.ux-home {
      flex-direction: column;

      .spread {
        display: none;
      }

      .left-menu .slogan .app-spread {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        width: 60px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 18px;
        color: $color-primary;
      }

      .ux-left {
        height: 60px;
      }

      .left-menu {
        height: 60px;
        z-index: 999;

        .ux-menu {
          position: fixed;
          top: 0;
          left: -240px;
          transition: all 0.2s;
          opacity: 0.9;

          &.ux-menu-app-show {
            left: 0;
            z-index: 999;
          }
        }
      }

      .dataShow {
        user-select: none;
        padding-bottom: 60px;

        .ux-date.is-range {
          top: 10px;
          right: 10px;
          width: 180px;

          .date-flex-align {
            flex-direction: column;
          }

          .shortcuts {
            display: flex;

            .shortcuts-item {
              padding: 5px 10px;
            }
          }

          .el-input__inner {
            padding: 0;
            font-size: 12px;
            line-height: 32px;
          }
        }

        .ux-row .ux-col:first-child .ux-date.is-range {
          z-index: 5;
        }
      }
    }

    .ux-right .main .header {
      padding: 0 15px;
      min-width: auto;

      .user-name {
        max-width: 56px;
      }
    }

    .main-view {
      box-sizing: border-box;
      padding-bottom: 60px;

      > div {
        min-width: 1000px;
      }
    }
  }
}
</style>
